<ng-container *transloco="let t;">
      <div class="detailFirstColumn">
        <label class="col-form-label">
          {{ t('Due Date text for details (Documents Section) - Due Date') }}
        </label>
      </div>
      <div class="docRightMenuDatePicker">
        <div class="form-group mb-0">
          <div class="input-group"
               [ngbTooltip]="tooltipText"
               triggers="hover">
            <div class="input-group-prepend me-50">
              <button [disabled]="isDueDateDisabled" 
                      class="btn-outline-secondary feather icon-calendar"
                      [config]="basicDateOptions"
                      type="button" 
                      rippleEffect>
              </button>
            </div>
            <input type="text" 
                   mwlFlatpickr 
                   [disable]="disableFlatpickr"
                   [value]="dueDateControl?.value"
                   (change)="onDateChange($event)"
                   class="form-control font-small-3 cursor-pointer"
                   [altInput]="true"
                   [altFormat]="(false | userTimeZoneFormat) | async"
                   [convertModelValue]="true"
                   />
          </div>
        </div>
      </div>
    </ng-container>